"use strict";
if (typeof Object.assign !== "function") {
    Object.assign = function (target, ...args) {
        if (!target) {
            throw TypeError("Cannot convert undefined or null to object");
        }
        for (const source of args) {
            if (source) {
                Object.keys(source).forEach((key) => (target[key] = source[key]));
            }
        }
        return target;
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/flatpickr/dist/esm/utils/polyfills.js
// module id = 433
// module chunks = 3